if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      // Add these checks
  if (!this.form) {
    console.error('Product form not found in product-form component');
    return;
  }
  
  const idInput = this.form.querySelector('[name=id]');
  if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart =  document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      this.hideErrors = this.dataset.hideErrors === 'true';
      if (document.querySelector('cart-drawer')) {
        this.submitButton?.setAttribute('aria-haspopup', 'dialog');
      }
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton?.setAttribute('aria-disabled', true);
      this.submitButton?.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      };
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(window.routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const errorMessage = response.description || response.message || 'An error occurred';
            this.handleErrorMessage(errorMessage);
            this.error = true;
            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton?.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            return;
          }
          this.error = false;
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('An error occurred. Please try again.');
        })
        .finally(() => {
          this.submitButton?.classList.remove('loading');
          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) {
            this.submitButton?.removeAttribute('aria-disabled');
          }
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        });
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
  customElements.define('product-form', ProductForm);
}
